import React, { useState } from "react";
import IPasswordDetails from "./IPasswordDetails";
import { SelectTabData, SelectTabEvent, Tab, TabList, TabValue, Tooltip } from "@fluentui/react-components";
import Details from "./details/Details";
import { InfoFilled, LockClosedFilled, Table16Regular } from "@fluentui/react-icons";
import MFA from "./MFA";
import Attributes from "./Attributes";

export default function Tabs(props: IPasswordDetails) {
    const { password } = props;

    const showMfa = password.mfa?.notes || (password.mfa?.tokens && password.mfa.tokens.length > 0);
    const showAttributes = password.attributes.length > 0;

    const showTabs = showMfa || showAttributes;

    const [selectedTab, setSelectedTab] = useState<TabValue>("tab-info");

    const handleTabSelect = (_: SelectTabEvent, data: SelectTabData) => setSelectedTab(data.value);

    const DetailsTab = React.memo(() => <Details password={password} />);
    const MfaTab = React.memo(() => <MFA password={password} />);
    const AttributesTab = React.memo(() => <Attributes password={password} />);

    return (
        <>
            {
                showTabs &&
                <TabList selectedValue={selectedTab} onTabSelect={handleTabSelect}>
                    <Tab value="tab-info">
                        <Tooltip content="Details" relationship="label">
                            <InfoFilled />
                        </Tooltip>
                    </Tab>
                    {
                        showMfa &&
                        <Tab value="tab-mfa">
                            <Tooltip content="MFA" relationship="label">
                                <LockClosedFilled />
                            </Tooltip>
                        </Tab>
                    }
                    {
                        showAttributes &&
                        <Tab value="tab-attributes">
                            <Tooltip content="Attributes" relationship="label">
                                <Table16Regular />
                            </Tooltip>
                        </Tab>
                    }
                </TabList>
            }
            <div style={{ margin: 0, maxWidth: "100%" }}>
                {selectedTab === "tab-info" && <DetailsTab />}
                {selectedTab === "tab-mfa" && showMfa && <MfaTab />}
                {selectedTab === "tab-attributes" && showAttributes && <AttributesTab />}
            </div>
        </>
    );
}